

export const toolbar_colors = [
    '#CF4C2C',
    '#EA9C41',
    '#EBC347',
    '#438D57',
    '#3F8AE2',
    '#803DEC',
  ];